function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  fill: "#0084ff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "check-mark",
  transform: "translate(6 7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M10.642.268a.917.917,0,0,1,0,1.3l-6.15,6.15a.917.917,0,0,1-1.3,0L.269,4.787a.917.917,0,0,1,1.3-1.3L3.844,5.77l5.5-5.5a.917.917,0,0,1,1.3,0Z",
  transform: "translate(0.045 0.042)",
  fill: "#fff"
}));

function SvgOperational(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperational);
export default __webpack_public_path__ + "static/media/operational.706284ca.svg";
export { ForwardRef as ReactComponent };